
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PropertyCorrections {
  livingAreaSqft?: number;
  buildingSqft?: number;
  garageSize?: string;
}

interface PropertyCorrectionsContextType {
  corrections: PropertyCorrections;
  updateCorrections: (newCorrections: Partial<PropertyCorrections>) => void;
  clearCorrections: () => void;
}

const PropertyCorrectionsContext = createContext<PropertyCorrectionsContextType | undefined>(undefined);

export const PropertyCorrectionsProvider = ({ children }: { children: ReactNode }) => {
  const [corrections, setCorrections] = useState<PropertyCorrections>({});

  const updateCorrections = (newCorrections: Partial<PropertyCorrections>) => {
    setCorrections(prev => ({ ...prev, ...newCorrections }));
  };

  const clearCorrections = () => {
    setCorrections({});
  };

  return (
    <PropertyCorrectionsContext.Provider value={{ corrections, updateCorrections, clearCorrections }}>
      {children}
    </PropertyCorrectionsContext.Provider>
  );
};

export const usePropertyCorrections = () => {
  const context = useContext(PropertyCorrectionsContext);
  if (context === undefined) {
    throw new Error('usePropertyCorrections must be used within a PropertyCorrectionsProvider');
  }
  return context;
};
